import React from "react";
import {useRenderableDataStore} from "./hooks/useRenderableDataStore";
interface ConfirmDeleteButtonProps {
    iconSrc: string;
    confirmingIconSrc: string;
    confirmText: string;
    onConfirm: () => void;
}
export let ConfirmDeleteButton = function (props: ConfirmDeleteButtonProps) {
    let dataStore = useRenderableDataStore({
        confirming: false
    });

    function onClickConfirmDeleteButton() {
        if (dataStore.data().confirming) {
            props.onConfirm();
        } else {
            dataStore.updateAndRender({confirming: true});
        }
    }

    return (
        <div
            className={`confirm-delete-button ${dataStore.data().confirming ? "confirming" : ""}`}
            onClick={onClickConfirmDeleteButton}
        >
            <div className="confirm-delete-button-icon-container">
                <img
                    className="confirm-delete-button-icon"
                    src={props.iconSrc}
                />
                <img
                    className="confirm-delete-button-icon confirming-icon"
                    src={props.confirmingIconSrc}
                />
            </div>
            <div className="confirm-delete-button-text">{props.confirmText}</div>
        </div>
    )
}